import BaseAPI from './base'
/**
 * API xử lý danh sách bài tập ôn luyện đã làm
 */
class ExerciseReferenceAPI extends BaseAPI {}

export default new ExerciseReferenceAPI('v1/exercise-reference', 'ExerciseReference')
